export default "__VITE_ASSET__6LCIZ$eR__"